// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2i2mz","question":"Question_question__DjZ6P","description":"Question_description__2xtGI"};